<script setup lang="ts">
import { computed } from 'vue';

import IconSpinner from './Icons/IconSpinner.vue';
const props = withDefaults(
  defineProps<{
    show: boolean;
    theme?: 'light' | 'dark';
  }>(),
  {
    show: false,
    theme: 'light'
  }
);
const bgColor = computed(() =>
  props.theme === 'light' ? 'bg-white/95' : 'bg-black'
);
</script>

<template>
  <Transition name="spinner">
    <div
      v-if="show"
      class="absolute left-0 top-0 z-10 flex size-full items-center justify-center text-center"
      :class="bgColor"
    >
      <div class="flex flex-col items-center gap-2 text-base">
        <IconSpinner class="text-3xl text-primary" />
        <span class="text-xs text-gray-400"><slot name="default" /></span>
      </div>
    </div>
  </Transition>
</template>
<style>
.spinner-enter-active,
.spinner-leave-active {
  transition: all 0.25s ease-in-out;
}
.spinner-leave-active {
  transition-delay: 0.25s;
}
.spinner-enter-from,
.spinner-leave-to {
  opacity: 0;
}
</style>
